import { sortByDisplayName } from '@/shared/lib/sort/sortByDisplayName';

import type { DomainHierarchyItem } from '@/entities/domain';

export type DomainTreeSelectNode = {
  key: string;
  value: string;
  title: string;
  children?: DomainTreeSelectNode[];
};

/**
 * DomainHierarchyItem 배열을 TreeSelect용 노드 배열로 변환합니다.
 * displayName 또는 name 기준으로 가나다순 정렬됩니다.
 */
export const transformDomainHierarchyToTreeSelect = (items: DomainHierarchyItem[]): DomainTreeSelectNode[] => {
  const sortedItems = sortByDisplayName(items);

  return sortedItems.map((item) => ({
    key: item.fullyQualifiedName,
    value: item.fullyQualifiedName,
    title: item.displayName || item.name,
    children:
      item.children && item.children.length > 0 ? transformDomainHierarchyToTreeSelect(item.children) : undefined,
  }));
};

/**
 * DomainHierarchyItem 배열에서 FQN으로 도메인을 찾습니다.
 */
export const findDomainByFqn = (items: DomainHierarchyItem[], fqn: string): DomainHierarchyItem | null => {
  for (const item of items) {
    if (item.fullyQualifiedName === fqn) {
      return item;
    }
    if (item.children && item.children.length > 0) {
      const found = findDomainByFqn(item.children, fqn);
      if (found) return found;
    }
  }
  return null;
};
